import moment from 'moment';
import { shallowEqual, useSelector } from 'react-redux';
import { Modal, ModalHeader } from 'reactstrap';
import UnMutePracticeForm from '../Forms/UnMutePracticeForm';
import MutePracticeForm from '../Forms/MutePracticeForm';
import React from 'react';

const MuteModal = () => {
    // TODO: make this feature its own redux slice
    const {
        isMutePracticeModalOpen,
        currentPracticeId,
        practiceId,
        practiceName,
        muteUntil,
    } = useSelector(
        (state) => ({
            isMutePracticeModalOpen: state.toggle.isMutePracticeModalOpen,
            currentPracticeId: state.practice.currentPracticeId,
            practiceName: state.practice.practiceToMute.name,
            practiceId: state.practice.practiceToMute.id,
            muteUntil: state.practice.practiceToMute?.practiceMute?.muteUntil,
        }),
        shallowEqual
    );

    const isMuted = muteUntil && moment.unix(muteUntil) > moment();
    const headerText = () =>
        isMuted ? `Unmute ${practiceName}?` : `Mute ${practiceName}`;

    const formProps = { practiceId, currentPracticeId };

    return (
        <Modal
            isOpen={isMutePracticeModalOpen}
            centered={true}
            className="text-light">
            <ModalHeader>{headerText()}</ModalHeader>
            {isMuted ? (
                <UnMutePracticeForm {...formProps} />
            ) : (
                <MutePracticeForm {...formProps} />
            )}
        </Modal>
    );
};

export default React.memo(MuteModal);
